module.exports = __webpack_public_path__ + "static/media/photo_1595534375490.aa3d346a.jpg";